import { useContext } from 'react';

import { navigate } from '@gatsbyjs/reach-router';
import grey from '@material-ui/core/colors/grey';
import Divider from '@material-ui/core/Divider';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import packageInfo from '../../../../package.json';
import { AppContext } from '../../../contexts/app-context';
import { HSBLogoImage } from '../../../utils/icons';
import {
  Avatar, Box, Button, Card, CardContent, CardHeader, Drawer, Typography
} from '../../../utils/material-ui-core';
import AppLogo from '../../app-logo';
import TermsConditions from '../../terms-conditions';
import MenuList from '../menu-list/index';

interface ILeftDrawerProps {
  isOpen: boolean;
  callbackDrawerClose: () => void;
  callbackToggleDarkTheme: () => void;
}

const LeftDrawer = ({ isOpen, callbackDrawerClose, callbackToggleDarkTheme }: ILeftDrawerProps) => {
  const pageStyles = LocalPageStyles();
  const { user, logoff } = useContext(AppContext);

  const handleLogoff = () => {
    logoff();
    navigate("/login");
  };

  const userInitials = () => {
    const charOfFirstname = user.information?.first?.substr(0, 1).toUpperCase() || " ";
    const charOflastname = user.information?.last?.substr(0, 1).toUpperCase() || " ";
    return charOfFirstname + charOflastname;
  };

  return (
    <Drawer classes={{ paper: pageStyles.drawer }} open={isOpen} onClose={callbackDrawerClose}>
      <Box width={1} role="presentation" onClick={callbackDrawerClose} onKeyDown={callbackDrawerClose} className={pageStyles.drawerMainBox}>
        <Box p={0}>
          <Card elevation={0} className={pageStyles.profileCard}>
            <CardHeader
              avatar={
                <Avatar aria-label="recipe" className={pageStyles.avatar}>
                  {userInitials()}
                </Avatar>
              }
              title={user.information?.first + "  " + user.information?.last}
              subheader={user.email}
            />
            <CardContent>
              <Box display="flex" justifyContent="center">
                <Button id="login-button-login" variant="contained" size="small" color="secondary" onClick={handleLogoff}>
                  LOGOUT
                </Button>
              </Box>
            </CardContent>
          </Card>
          <Divider />
        </Box>
        <Box display="columns" p={0} className={pageStyles.scrollContent}>
          <Box className={pageStyles.drawerMainMenuBox}>
            <MenuList callbackToggleDarkTheme={callbackToggleDarkTheme} />
          </Box>

          <Box>
            <Divider />
            <Box p={1}>&nbsp;</Box>
            <Box p={2} display="flex" justifyContent="center" alignContent="center">
              <TermsConditions />
            </Box>
            <Box p={1}>&nbsp;</Box>
            <Box display="flex" p={0} justifyContent="center" alignItems="center">
              <img src={HSBLogoImage} alt="Logo" className={pageStyles.logoImage} />
              <AppLogo />
            </Box>
            <Box p={1} display="flex" justifyContent="center" alignContent="center">
              <Typography variant="subtitle2">
                <small>ver {packageInfo.version}</small>
              </Typography>
            </Box>
            <Box p={3}>&nbsp;</Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: 350,
      height: "100vh",
      overflow: "hidden",
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[50],
    },
    drawerMainBox: {
      height: "180px",
    },
    drawerMainMenuBox: {
      minHeight: "60vh",
    },
    profileCard: {
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[50],
    },
    scrollContent: {
      height: "88vh",
      overflowY: "auto",
      overflowX: "hidden",
      justify: "space-between",
      alignItems: "center",
      display: "columns",
    },
    avatar: {
      backgroundColor: grey[500],
    },
    logoImage: {
      marginLeft: 10,
      marginRight: 10,
      backgroundColor: theme.palette.type === "dark" ? grey[400] : "transparent",
      borderRadius: 4,
    },
  })
);

export default LeftDrawer;
